var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairCable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Pair_Cable_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pair_Cable_",
    "data-name": "Pair Cable ",
    clipPath: "url(#clip-Pair_Cable_)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cable",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 239.318, -212.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(198.2 260.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M219.8,264.8c-.8,3.61-.4,8.121-.4,12.633,0,15.341-2.8,28.876-4.4,43.315.4-6.317.8-12.633,1.2-18.048.4-3.61,1.2-8.121,1.2-11.731a66.462,66.462,0,0,0,0-12.633c-.4-4.512-.4-9.024-1.2-13.536-.4,2.707,0,5.414,0,9.024.4,10.829-.8,21.657-2,33.388V283.75c-.4,4.512-.4,9.024-.8,13.536,0-9.024-.4-18.048-.8-27.072,0,5.414,0,10.829.4,16.243v-8.121c0,3.61-.4,7.219-.4,10.829,0-7.219-.4-14.438-.8-20.755a397.96,397.96,0,0,1-.4,43.315c-.8-10.829-1.6-20.755-1.6-29.779v-7.219a33.526,33.526,0,0,1-.4,6.317,33.526,33.526,0,0,0-.4-6.317v7.219c0,9.024-.8,18.95-1.6,29.779-.8-16.243-.4-30.681-.4-43.315-.4,6.317-.4,13.536-.8,20.755,0-3.61-.4-7.219-.4-10.829v8.121c0-5.414,0-10.829.4-16.243-.4,9.024-.4,18.048-.8,27.072,0-4.512-.4-9.024-.8-13.536v23.462c-1.2-12.633-2.4-23.462-2-33.388,0-2.707.4-6.317,0-9.024l-1.2,13.536c0,4.512-.4,8.121,0,12.633.4,3.61.8,7.219,1.2,11.731.8,5.414.8,11.731,1.2,18.048-2-14.438-4.8-28.876-4.4-43.315,0-4.512.4-8.121-.4-12.633-.4,6.317-.8,12.633-.8,18.95a110.481,110.481,0,0,0,.8,16.243c.4,4.512,1.6,8.121,2,12.633a207.073,207.073,0,0,1,2.8,27.072c0,1.8-.4,3.61-.4,4.512.4,0,.4.9.8.9,0,5.414.4,10.829.4,16.243,2-.9,3.2-3.61,4.8-6.317,1.6,2.707,2.8,5.414,4.8,6.317,0-5.414.4-10.829.4-16.243.4,0,.4-.9.8-.9,0-1.8-.4-2.707-.4-4.512a192.077,192.077,0,0,1,2.8-27.072c.8-4.512,1.6-8.121,2-12.633a110.479,110.479,0,0,0,.8-16.243A150.183,150.183,0,0,0,219.8,264.8Zm-10,60.46h0v0Z",
    transform: "translate(-198.2 -315.526)",
    fill: "#ffd05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M259.409,393.751c-3.5-3.592-7-8.382-11.007-11.974.5-10.777-1-22.751-1.5-33.528-1.5-16.764-1.5-33.528-1.5-50.292a283.973,283.973,0,0,1,4.5,31.133c.5,5.987.5,11.974.5,17.962,0,7.185,0,15.567.5,22.751,2.5-3.592,3-10.777,3-16.764.5-25.146-1.5-50.292-3-75.438a393.767,393.767,0,0,1,6.5,98.19c2-29.936,1.5-59.872,1-89.808,1.5,28.738,3,58.674,4,87.413,1-28.738,1-58.674,0-87.413,1,16.764,2,34.726,2,51.49,0,10.777-.5,22.751-1,33.528,0,5.987-.5,10.777-.5,16.764,0,3.592-.5,7.185-2,7.185C260.41,394.949,259.909,393.751,259.409,393.751Z",
    transform: "translate(-200.551 -334.2)",
    fill: "#ffd05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M305.8,280.8c-.8,10.8,1.6,21.6-1.6,31.6-.4,1.6-1.6,3.6-3.2,4s-2.8-.8-4-2a21.983,21.983,0,0,0-2.8-3.6,2.851,2.851,0,0,1-1.2-2.4c0-.4.4-.8.4-1.2A20.755,20.755,0,0,0,295,296c-.4-3.6-1.2-7.6-1.2-11.2a36.778,36.778,0,0,1,1.2,20.8c-.4,1.6-1.2,3.2-.8,4.8,1.6-2,2-4.4,2.4-6.8a75.442,75.442,0,0,0-.8-21.2,110.229,110.229,0,0,1,2,30.4c.8-10.8-.8-22,2-32.4-1.6,11.2,4,22.8.8,33.6a55.752,55.752,0,0,1,1.2-20c.4-2.4,1.2-5.2,1.6-7.6s0-4.8,1.2-6.8v25.6a14.38,14.38,0,0,1-.8,4.4c-.4,1.6-.8,3.6-1.2,5.2A122.611,122.611,0,0,0,305.8,280.8Z",
    transform: "translate(-198.2 -260.073)",
    fill: "#ffd05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M303.4,280.8c-.8,10.8,1.6,21.6-1.6,31.6-.4,1.6-1.6,3.6-3.2,4s-2.8-.8-4-2-1.6-2.4-2.8-3.6a2.851,2.851,0,0,1-1.2-2.4c0-.4.4-.8.4-1.2a20.755,20.755,0,0,0,1.6-11.2c-.4-3.6-1.2-7.6-1.2-11.2a36.778,36.778,0,0,1,1.2,20.8c-.4,1.6-1.2,3.2-.8,4.8,1.6-2,2-4.4,2.4-6.8a75.442,75.442,0,0,0-.8-21.2,110.229,110.229,0,0,1,2,30.4c.8-10.8-.8-22,2-32.4-1.6,11.2,4,22.8.8,33.6a55.752,55.752,0,0,1,1.2-20c.4-2.4,1.2-5.2,1.6-7.6s0-4.8,1.2-6.8v25.6a14.38,14.38,0,0,1-.8,4.4c-.4,1.6-.8,3.6-1.2,5.2A109.128,109.128,0,0,0,303.4,280.8Z",
    transform: "translate(-198.2 -260.073)",
    fill: "#ffd05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M291,280.8c.8,10.8-1.6,21.6,1.6,31.6.4,1.6,1.6,3.6,3.2,4s2.8-.8,4-2a21.983,21.983,0,0,1,2.8-3.6,2.851,2.851,0,0,0,1.2-2.4c0-.4-.4-.8-.4-1.2a20.755,20.755,0,0,1-1.6-11.2c.4-3.6,1.2-7.6,1.2-11.2a36.778,36.778,0,0,0-1.2,20.8c.4,1.6,1.2,3.2.8,4.8-1.6-2-2-4.4-2.4-6.8a75.442,75.442,0,0,1,.8-21.2,110.229,110.229,0,0,0-2,30.4c-.8-10.8.8-22-2-32.4,1.6,11.2-4,22.8-.8,33.6a55.752,55.752,0,0,0-1.2-20c-.4-2.4-1.2-5.2-1.6-7.6s0-4.8-1.2-6.8v25.6a14.38,14.38,0,0,0,.8,4.4c.4,1.6.8,3.6,1.2,5.2A122.613,122.613,0,0,1,291,280.8Z",
    transform: "translate(-198.2 -260.073)",
    fill: "#ffd05b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M265.4,419.6a71.332,71.332,0,0,1,5.6-36.4c1.6-3.6,3.6-7.2,5.6-10.8s3.6-6.8,5.2-10c4-9.2,5.2-19.6,6.4-29.6l3.2-26,16,2-3.2,26c-1.2,10.8-2.8,22.8-7.6,34a105.561,105.561,0,0,1-6,11.6c-1.6,3.2-3.6,6.4-4.8,9.2a55.944,55.944,0,0,0-4.4,28Z",
    transform: "translate(0 2.201)",
    fill: "#3338d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M250.6,423.6,235,420c4-18.4,8-37.2,10-55.6,2-18.8,1.2-38.4.8-57.2l16-.4c.4,19.2,1.2,39.6-.8,59.2S255,405.2,250.6,423.6Z",
    transform: "translate(0 2.271)",
    fill: "#ff7058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M227.8,424l-16-.8,4-69.6a56.759,56.759,0,0,0-.4-14.4c-.8-4.4-3.2-9.2-5.6-14-4-7.6-8.4-16.4-7.6-26.4l16,1.2c-.4,5.6,2.4,11.6,6,18.4a89.023,89.023,0,0,1,7.2,18c1.2,6.4.8,12.8.8,18.4Z",
    fill: "#158d29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M296.2,404V589.4a135.205,135.205,0,0,1-42,6.621c-18,0-35.6-3.679-52.8-10.3V404Z",
    transform: "translate(0 6.855)",
    fill: "#324a5e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairCable);
export default __webpack_public_path__ + "static/media/Pair Cable.9237af9ff8d063e446068feb64a2ef7f.svg";
export { ForwardRef as ReactComponent };